// src/features/security/components/SecurityWorkspaceHeader.tsx
import { Card, formatPersianNumber, formatSolarDate } from '../../../app/components/foundation';
import type { SecurityModule } from '../data/security.mock';
import { SecurityStatusBadge } from './SecurityStatusBadge';

export interface SecurityWorkspaceHeaderProps {
  module: SecurityModule;
}

/**
 * Top-of-page header for the security workspace. Same glass Card
 * surface as every other card here, but laid out as identity (module
 * name + status badge) plus a small meta list (id, access level, last
 * changed) on one side and a reserved action area on the other. The
 * action button is disabled and non-functional, same placeholder
 * pattern as CommissionWorkspaceHeader / UserWorkspaceHeader — real
 * workspace actions (disable module, edit policy, etc.) are a later
 * phase.
 */
export function SecurityWorkspaceHeader({ module }: SecurityWorkspaceHeaderProps) {
  return (
    <Card className="vania-security-workspace-header">
      <div className="vania-security-workspace-header-main">
        <div className="vania-security-workspace-header-identity">
          <h1 className="vania-security-workspace-name">{module.moduleName}</h1>
          <SecurityStatusBadge status={module.status} />
        </div>

        <dl className="vania-security-workspace-meta">
          <div>
            <dt>شناسه ماژول</dt>
            <dd dir="ltr">{formatPersianNumber(module.id)}</dd>
          </div>
          <div>
            <dt>سطح دسترسی</dt>
            <dd>{module.accessLevel}</dd>
          </div>
          <div>
            <dt>آخرین تغییر</dt>
            <dd dir="ltr">{formatSolarDate(module.lastChangedAt)}</dd>
          </div>
        </dl>
      </div>

      <div className="vania-security-workspace-header-actions">
        <button
          type="button"
          disabled
          className="vania-security-action-placeholder"
          title="در فاز بعدی فعال می‌شود"
        >
          عملیات ماژول
        </button>
      </div>
    </Card>
  );
}
